import React from 'react';

const SpotReservationNotice = () => {
  return (
    <div className="spot-reservation-notice">
      <p>Spots are not reserved or held until checkout is complete.</p>
    </div>
  );
};

export default SpotReservationNotice;



// WEBPACK FOOTER //
// ./src/components/SpotReservationNotice.js